import { render, staticRenderFns } from "./TitluPagina.vue?vue&type=template&id=d20d5a54&scoped=true&"
import script from "./TitluPagina.vue?vue&type=script&lang=js&"
export * from "./TitluPagina.vue?vue&type=script&lang=js&"
import style0 from "./TitluPagina.vue?vue&type=style&index=0&id=d20d5a54&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20d5a54",
  null
  
)

export default component.exports